"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFullName = getFullName;
exports.getInitials = getInitials;
exports.getTestId = getTestId;
function toFirstLast(person) {
    if (typeof person === 'string') {
        const parts = person.split(' ');
        if (parts.length === 1) {
            return [parts[0], ''];
        }
        else if (parts.length > 1) {
            return [parts.slice(0, -1).join(' '), parts.slice(-1).join(' ')];
        }
        else {
            return ['', ''];
        }
    }
    else {
        return 'firstName' in person
            ? [
                person.preferredFirstName || person.firstName,
                person.preferredLastName || person.lastName,
            ]
            : [
                person.preferredGivenName || person.givenName,
                person.preferredFamilyName || person.familyName,
            ];
    }
}
/**
 * Gets the full name for a person
 * @param person object with name properties
 */
function getFullName(person) {
    if (!person) {
        return '';
    }
    const [first, last] = toFirstLast(person);
    return `${first !== null && first !== void 0 ? first : ''} ${last !== null && last !== void 0 ? last : ''}`;
}
/**
 * Gets the initials for a person
 * @param person object with name properties
 */
function getInitials(person) {
    var _a, _b, _c;
    if (!person) {
        return '';
    }
    const [first, last] = toFirstLast(person);
    return `${(_b = (_a = first === null || first === void 0 ? void 0 : first.charAt(0)) === null || _a === void 0 ? void 0 : _a.toLocaleUpperCase()) !== null && _b !== void 0 ? _b : ''}${(_c = last === null || last === void 0 ? void 0 : last.charAt(0).toLocaleUpperCase()) !== null && _c !== void 0 ? _c : ''}`;
}
/**
 * Gets the testId for a person
 * @param person object with name properties
 */
function getTestId(person) {
    if (!person) {
        return '';
    }
    const [first, last] = toFirstLast(person);
    return `${first !== null && first !== void 0 ? first : ''}_${last !== null && last !== void 0 ? last : ''}`;
}
//# sourceMappingURL=name.js.map